<style>
#addEventModal .v-messages__message {
  line-height: unset;
}
#addEventModal .modal__content {
  margin-top: 15px;
}
#addEventModal .v--modal-box.v--modal {
  min-height: 250px !important;
  min-width: 400px !important;
  max-width: 400px !important;
  max-height: 250px !important;
}
#addEventModal .modal__footer {
  padding-bottom: 10px;
}
#addEventModal .v-label.theme--light.error--text {
  font-size: 12px !important;
}
</style>

<template>
  <Modal
    modalName="addEventModal"
    title="Dodaj komentarz"
    :buttons="['add']"
    @add="addEvent"
    @closed="closed"
  >
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-textarea
        :height="100"
        name
        label="Treść komentarza"
        v-model="text"
        autofocus
        :rules="textRules"
      ></v-textarea>
    </v-form>
  </Modal>
</template>

<script>
import Modal from "./Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    valid: true,
    text: "",
    textRules: [v => !!v || "Treść zdarzenia jest wymagana"]
  }),
  computed: {
    currentEditedObject() {
      return this.$store.getters.getCurrentEditedObject;
    }
  },
  methods: {
    addEvent() {
      if(this.$refs.form.validate()) {
        let payload = {
          content: this.text,
          event_type: "comments",
          object_id: this.currentEditedObject.object_id,
          object_table: this.currentEditedObject.object_table,
          object_type: this.currentEditedObject.object_type,
          limit: 5,
          events_count: true
        };
        if(payload.object_table == undefined) delete payload.object_table
        this.$store.dispatch("addEvent", payload).then(succsess => {
          if(succsess) {
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Pomyślnie dodano zdarzenie"
            );
            this.$store.dispatch("getFeatureEvents", payload).then(r => {
              this.$root.$emit("refreshEvents", payload.object_type);
              this.$modal.hide("addEventModal");
            });
          } else {
            this.$root.$emit(
              "showSnackbar",
              "red",
              "Podczas dodawania zdarzenia wystąpił błąd"
            );
          }
        });
      }
    },
    closed() {
      this.text = "";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/shared/AddEvent.vue